module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/conf/price-rule-add-table/price-rule-add-table.component.css
// module id = ./src/app/conf/price-rule-add-table/price-rule-add-table.component.css
// module chunks = main